import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';

@Directive({
  selector: '[ngCan]',
  standalone: true
})
export class NgCanDirective {

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private authService: AuthService,
  ) {}

  @Input() set ngCan(allowedPermission: string) {
    const canPermission = this.authService.ngCan(allowedPermission);
    if (canPermission) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
